module.exports = __webpack_public_path__ + "static/media/400131_01.ed04553c.png";